import styles from './SwapGraph.module.css';
import {
  Graph,
  SwapHeader,
  CurrencyConverter,
  ExtraInfo,
  Button,
  SwapGraphInfo,
} from '../../components';
import ContentContainer from '../../components/misc/ContentContainer/ContentContainer';

const ButtonDisplay = (
  <div className={styles.button_container}>
    <Button title='Swap' />
  </div>
);
const graphSwap = (
  <div>
    <CurrencyConverter />
    <ExtraInfo />
    {ButtonDisplay}
  </div>
);

const graphTitle = (
  <div className={styles.graph_title}>
    <div className={styles.tokens_container}>
      <img
        src='https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Ethereum-icon-purple.svg/480px-Ethereum-icon-purple.svg.png'
        alt='ethereum'
        width='25px'
      />
      <span>AMBI</span>
      <span className={styles.slash}>/</span>
      <img
        src='https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Ethereum-icon-purple.svg/480px-Ethereum-icon-purple.svg.png'
        alt='ethereum'
        width='25px'
      />
      <span>ETH</span>
      <span className={styles.header1}> 2658.00</span>
    </div>

    <div className={styles.amount_container}>
      <span>+8.57% | 24h</span>
      <span>+15.87% | 7d</span>
      <span>+5.31% | 30d</span>
    </div>
  </div>
);
const SwapGraph = () => {
  return (
  

    <ContentContainer customWidthAuto>
          <div className={styles.liq_container}>
            <div className={styles.graphs_container}>
              <div className={styles.title}>{graphTitle}</div>
              <Graph />
            </div>

            <div className={styles.swaps_container}>
              <div className={styles.title}>
                <SwapHeader />
              </div>
              <div>{graphSwap}</div>
            </div>
          </div>
          <SwapGraphInfo />
    </ContentContainer>
  );
};

export default SwapGraph;
